import {all} from "redux-saga/effects";
import { combineReducers } from "redux";
import * as auth from "../app/modules/Auth/_redux/authRedux";
import { moduleSlice } from "../app/modules/SystemManagement/_redux/modules/ModulesSlice";
import { systemLogSlice } from "../app/modules/SystemManagement/_redux/system-logs/SystemLogsSlice";
import { userLogSlice } from "../app/modules/SystemManagement/_redux/user-logs/UserLogsSlice";
import { dashboardSlice } from "../app/_redux/DashboardSlice";
import { userGroupSlice } from "../app/modules/UserActions/_redux/user-groups/UserGroupsSlice";
import { systemUserSlice } from "../app/modules/UserActions/_redux/system-users/SystemUsersSlice";
import { userAssignmentSlice } from "../app/modules/UserActions/_redux/user-assignment/UserAssignmentSlice";
import { userActionSlice } from "../app/modules/UserActions/_redux/user-actions/UserActionsSlice";
import { noticeGroupSlice } from "../app/modules/UserActions/_redux/notice-groups/NoticeGroupsSlice";
import { personAssignmentSlice } from "../app/modules/UserActions/_redux/person-assignment/PersonAssignmentSlice";
import { publicNoticeSlice } from "../app/modules/UserActions/_redux/public-notices/PublicNoticesSlice";
import { privateNoticeSlice } from "../app/modules/UserActions/_redux/private-notices/PrivateNoticesSlice";
import { userGroupAuthorizationSlice } from "../app/modules/UserActions/_redux/user-group-authorization/UserGroupAuthorizationSlice";
import { userAuthorizationSlice } from "../app/modules/UserActions/_redux/user-authorization/UserAuthorizationSlice";
import { schoolProfileSlice } from "../app/modules/DefinitionActions/_redux/school-profile/SchoolProfileSlice";
import { educationTermSlice } from "../app/modules/DefinitionActions/_redux/education-terms/EducationTermsSlice";
import { courseSlice } from "../app/modules/DefinitionActions/_redux/courses/CoursesSlice";
import { gradeCourseSlice } from "../app/modules/DefinitionActions/_redux/grade-courses/GradeCoursesSlice";
import { courseSubjectSlice } from "../app/modules/DefinitionActions/_redux/course-subjects/CourseSubjectsSlice";
import { subjectOutcomeSlice } from "../app/modules/DefinitionActions/_redux/subject-outcomes/SubjectOutcomesSlice";
import { sectionSlice } from "../app/modules/DefinitionActions/_redux/sections/SectionsSlice";
import { levelSectionSlice } from "../app/modules/DefinitionActions/_redux/level-sections/LevelSectionsSlice";
import { timetableSlice } from "../app/modules/DefinitionActions/_redux/timetable/TimeTableSlice";
import { teacherCourseSlice } from "../app/modules/DefinitionActions/_redux/teacher-courses/TeacherCoursesSlice";
import { advisorSlice } from "../app/modules/DefinitionActions/_redux/advisors/AdvisorsSlice";
import { branchSlice } from "../app/modules/DefinitionActions/_redux/branches/BranchesSlice";
import { occupationCategorySlice } from "../app/modules/DefinitionActions/_redux/occupation-categories/OccupationCategoriesSlice";
import { personnelTypeSlice } from "../app/modules/DefinitionActions/_redux/personnel-types/PersonnelTypesSlice";
import { activityTypeSlice } from "../app/modules/DefinitionActions/_redux/activity-types/ActivityTypesSlice";
import { bookSlice } from "../app/modules/DefinitionActions/_redux/books/BooksSlice";
import { homeworkSourceSlice } from "../app/modules/DefinitionActions/_redux/homework-sources/HomeworkSourcesSlice";
import { studentSlice } from "../app/modules/RegistrationActions/_redux/students/StudentsSlice";
import { unregisteredStudentSlice } from "../app/modules/RegistrationActions/_redux/unregistered-students/UnregisteredStudentsSlice";
import { studentPreInterviewSlice } from "../app/modules/RegistrationActions/_redux/student-pre-interviews/StudentPreInterviewsSlice";
import { studentLevelSectionSlice } from "../app/modules/RegistrationActions/_redux/student-level-section/StudentAssignmentSlice";
import { sectionRenewalSlice } from "../app/modules/RegistrationActions/_redux/section-renewal/SectionRenewalSlice";
import { studentReportSlice } from "../app/modules/RegistrationActions/_redux/student-report/StudentReportSlice";
import { gradeAndSectionReportSlice } from "../app/modules/RegistrationActions/_redux/grade-and-section-report/GradeAndSectionReportSlice";
import { personnelSlice } from "../app/modules/RegistrationActions/_redux/personnels/PersonnelsSlice";
import { personnelReportSlice } from "../app/modules/RegistrationActions/_redux/personnel-report/PersonnelReportSlice";
import { teacherSlice } from "../app/modules/RegistrationActions/_redux/teachers/TeachersSlice";
import { attendanceSlice } from "../app/modules/RegistrationActions/_redux/attendance/AttendanceSlice";
import { schoolReportSlice } from "../app/modules/PerformanceReporting/_redux/school-reports/SchoolReportsSlice";
import { studentBookReportSlice } from "../app/modules/PerformanceReporting/_redux/student-book-report/StudentBookReportSlice";
import { activityReportSlice } from "../app/modules/PerformanceReporting/_redux/activity-report/ActivityReportSlice";
import { dailyAttendanceReportSlice } from "../app/modules/PerformanceReporting/_redux/daily-attendance-report/DailyAttendanceReportSlice";
import { studentAbsenteeismReportSlice } from "../app/modules/PerformanceReporting/_redux/student-absenteeism-report/StudentAbsenteeismReportSlice";
import { homeworkSlice } from "../app/modules/PerformanceReporting/_redux/homeworks/HomeworksSlice";
import { teacherPersonnelSlice } from "../app/modules/Teacher/_redux/personnels/PersonnelsSlice";
import { myStudentSlice } from "../app/modules/Teacher/_redux/my-students/MyStudentsSlice";
import { myAdvisorStudentSlice } from "../app/modules/Teacher/_redux/my-advisor-students/MyAdvisorStudentsSlice";
import { myCourseSlice } from "../app/modules/Teacher/_redux/my-courses/MyCoursesSlice";
import { examGradeSlice } from "../app/modules/Teacher/_redux/exam-grades/ExamGradesSlice";
import { teacherTimetableSlice } from "../app/modules/Teacher/_redux/timetable/TimeTableSlice";
import { teacherNoticeSlice } from "../app/modules/Teacher/_redux/notices/NoticesSlice";
import { activitySlice } from "../app/modules/Teacher/_redux/activities/ActivitiesSlice";
import { teacherAttendanceSlice } from "../app/modules/Teacher/_redux/attendance/AttendanceSlice";
import { dailySubjectTrackingSlice } from "../app/modules/Teacher/_redux/daily-subject-tracking/DailySubjectTrackingSlice";
import { teacherHomeworkSlice } from "../app/modules/Teacher/_redux/homework-management/HomeworksSlice";
import { teacherBookSlice } from "../app/modules/Teacher/_redux/book-management/BooksSlice";
import { myTeacherSlice } from "../app/modules/Student/_redux/my-teachers/MyTeachersSlice";
import { myClassmateSlice } from "../app/modules/Student/_redux/my-classmates/MyClassmatesSlice";
import { studentMyCourseSlice } from "../app/modules/Student/_redux/my-courses/MyCoursesSlice";
import { studentTimetableSlice } from "../app/modules/Student/_redux/timetable/TimeTableSlice";
import { studentHomeworkSlice } from "../app/modules/Student/_redux/homeworks/HomeworksSlice";
import { sectionSubjectProgressSlice } from "../app/modules/Student/_redux/section-subject-progress/SectipnSubjectProgressSlice";
import { myAbsenteeismSlice } from "../app/modules/Student/_redux/my-absenteeisms/MyAbsenteeismsSlice";
import { studentActivitySlice } from "../app/modules/Student/_redux/activities/ActivitiesSlice";
import { studentNoticeSlice } from "../app/modules/Student/_redux/notices/NoticesSlice";
import { studentBookSlice } from "../app/modules/Student/_redux/book-management/BooksSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  modules: moduleSlice.reducer,
  userLogs: userLogSlice.reducer,
  systemLogs: systemLogSlice.reducer,
  dashboard: dashboardSlice.reducer,
  userGroups: userGroupSlice.reducer,
  systemUsers: systemUserSlice.reducer,
  userAssignment: userAssignmentSlice.reducer,
  userActions: userActionSlice.reducer,
  noticeGroups: noticeGroupSlice.reducer,
  personAssignment: personAssignmentSlice.reducer,
  publicNotices: publicNoticeSlice.reducer,
  privateNotices: privateNoticeSlice.reducer,
  userGroupAuthorization: userGroupAuthorizationSlice.reducer,
  userAuthorization: userAuthorizationSlice.reducer,
  schoolProfile: schoolProfileSlice.reducer,
  educationTerms: educationTermSlice.reducer,
  courses: courseSlice.reducer,
  gradeCourses: gradeCourseSlice.reducer,
  courseSubjects: courseSubjectSlice.reducer,
  subjectOutcomes: subjectOutcomeSlice.reducer,
  sections: sectionSlice.reducer,
  levelSections: levelSectionSlice.reducer,
  timetable: timetableSlice.reducer,
  teacherCourses: teacherCourseSlice.reducer,
  advisors: advisorSlice.reducer,
  branches: branchSlice.reducer,
  occupationCategories: occupationCategorySlice.reducer,
  personnelTypes: personnelTypeSlice.reducer,
  activityTypes: activityTypeSlice.reducer,
  books: bookSlice.reducer,
  homeworkSources: homeworkSourceSlice.reducer,
  students: studentSlice.reducer,
  unregisteredStudents: unregisteredStudentSlice.reducer,
  studentPreInterviews: studentPreInterviewSlice.reducer,
  studentLevelSection: studentLevelSectionSlice.reducer,
  sectionRenewal: sectionRenewalSlice.reducer,
  studentReport: studentReportSlice.reducer,
  gradeAndSectionReport: gradeAndSectionReportSlice.reducer,
  personnels: personnelSlice.reducer,
  personnelReport: personnelReportSlice.reducer,
  teachers: teacherSlice.reducer,
  attendance: attendanceSlice.reducer,
  schoolReports: schoolReportSlice.reducer,
  studentBookReport: studentBookReportSlice.reducer,
  activityReport: activityReportSlice.reducer,
  dailyAttendanceReport: dailyAttendanceReportSlice.reducer,
  studentAbsenteeismReport: studentAbsenteeismReportSlice.reducer,  
  homeworks: homeworkSlice.reducer,
  teacherPersonnels: teacherPersonnelSlice.reducer,
  myStudents: myStudentSlice.reducer,
  myAdvisorStudents: myAdvisorStudentSlice.reducer,
  myCourses: myCourseSlice.reducer,
  examGrades: examGradeSlice.reducer,
  teacherTimetable: teacherTimetableSlice.reducer,
  teacherNotices: teacherNoticeSlice.reducer,
  activities : activitySlice.reducer,
  teacherAttendance: teacherAttendanceSlice.reducer,
  dailySubjectTracking: dailySubjectTrackingSlice.reducer,
  teacherHomeworks: teacherHomeworkSlice.reducer,
  teacherBooks: teacherBookSlice.reducer,
  myTeachers: myTeacherSlice.reducer,
  myClassmates: myClassmateSlice.reducer,
  studentMyCourses: studentMyCourseSlice.reducer, 
  studentTimetable: studentTimetableSlice.reducer,
  studentHomeworks: studentHomeworkSlice.reducer,
  sectionSubjectProgress: sectionSubjectProgressSlice.reducer,
  myAbsenteeisms: myAbsenteeismSlice.reducer,
  studentActivities: studentActivitySlice.reducer,
  studentNotices: studentNoticeSlice.reducer,
  studentBooks: studentBookSlice.reducer
});

export function* rootSaga() {
  //yield all([auth.saga()]);
}